// @flow
import React from 'react';
import moment from 'moment';
import type { Project } from '../../models/projects/Project';
import {
  STATUS,
  EDITOR,
  STOCK_TYPE,
  ANGEL_TYPE,
  SURPLUS,
  PATENT,
  SHAREHOLDER_BENEFIT,
} from '../../models/projects/Project';
import { stripTags } from '../../helpers/ApplicationHelper';

type Props = {
  project: Project,
};

export default function CardDescription(props: Props) {
  const { project } = props;

  function angelTypeName() {
    if (project.description_angel_type === ANGEL_TYPE.none) {
      return 'エンジェル税制なし';
    } else if (project.description_angel_type === ANGEL_TYPE.typeA) {
      return 'エンジェル税制タイプA';
    } else if (project.description_angel_type === ANGEL_TYPE.typeB) {
      return 'エンジェル税制タイプB';
    } else if (project.description_angel_type === ANGEL_TYPE.typeBOtherwiseA) {
      return 'エンジェル税制B (Aの可能性有)';
    }
  }

  function stockTypeName() {
    if (project.description_stock_type === STOCK_TYPE.commonStock) {
      return '普通株式';
    } else if (project.description_stock_type === STOCK_TYPE.stockOption) {
      return '新株予約権';
    }
  }

  function surplusName() {
    if (project.description_surplus === SURPLUS.nothing) {
      return '直前期収益黒字化していない';
    } else if (project.description_surplus === SURPLUS.exist) {
      return '直前期収益黒字化している';
    } else if (project.description_surplus === SURPLUS.expecting) {
      return '直前期収益黒字化見込み';
    }
  }

  function patentName() {
    if (project.description_patent === PATENT.nothing) {
      return '特許なし';
    } else if (project.description_patent === PATENT.exist) {
      return '特許あり';
    } else if (project.description_patent === PATENT.pending) {
      return '特許申請中';
    } else if (project.description_patent === PATENT.transferring) {
      return '特許あり (譲受予定)';
    }
  }

  function shareholderBenefitName() {
    if (
      project.description_shareholder_benefit === SHAREHOLDER_BENEFIT.nothing
    ) {
      return '株主優待なし';
    } else if (
      project.description_shareholder_benefit ===
      SHAREHOLDER_BENEFIT.for_stockholder
    ) {
      return '株主優待あり';
    } else if (
      project.description_shareholder_benefit ===
      SHAREHOLDER_BENEFIT.for_optionholder
    ) {
      return '新株予約権者優待あり';
    }
  }

  if (project.status === STATUS.failed) {
    if (project.withdraw_reason) {
      return (
        <div className="description">{stripTags(project.withdraw_reason)}</div>
      );
    } else if (project.execution_at) {
      if (project.execution_at < project.failed_at) {
        return (
          <div className="description">
            このプロジェクトは、目標募集金額を上回って募集が終了し、約定いたしましたが、その後、一部の投資家様からの払い込みがなかったため、失権により目標募集額を下回ってしまいました。
            発行者と協議の結果、発行者の判断により募集を中止させていただきました。
            ご応募・ご検討いただいた投資家の皆様には誠に申し訳ございません。
            なお、すでに払い込みいただいた投資家様には別途メールにてご連絡させていただいておりますのでそちらもご確認くださいますようよろしくお願いいたします。
          </div>
        );
      } else {
        return (
          <div className="description">
            このプロジェクトは
            {moment(project.finish_at).format('YYYY年MM月DD日')}
            をもちまして募集を終了いたしましたのでお申込みいただく事はできません。
            なお、このプロジェクトは目標募集額を上回って終了したものの、キャンセル可能期間中において目標募集額を下回ったために不成立となり、お申込みいただいたご注文は取り消されました。
            応募金額は募集期間終了時点のものです。
          </div>
        );
      }
    } else {
      if (project.is_withdraw) {
        if (project.id === 154) {
          return (
            <div className="description">
              このプロジェクトは、発行者より募集の延期要請があり、発行者と協議の結果、当初予定していた
              {moment(project.start_at).format('YYYY年MM月DD日')}
              からの募集を一旦取り下げさせていただきました。
              ご検討いただいた投資家の皆様には誠に申し訳ございません、今後募集を行う場合には、投資家の皆様にあらためてご連絡させていただきます。
            </div>
          );
        } else if (project.failed_at && project.start_at < project.failed_at) {
          return (
            <div className="description">
              このプロジェクトは、ここ最近の諸事情を鑑み、発行者の要請により、
              {moment(project.failed_at).format('YYYY年MM月DD日')}
              をもちまして募集の取扱いを取り下げられましたのでお申込みいただくことができません。
              <br />
              なお、応募金額は取り下げた時点における金額です。
            </div>
          );
        } else {
          return (
            <div className="description">
              {moment(project.start_at).format('YYYY年MM月DD日')}
              よりお申込み開始を予定しておりましたこのプロジェクトは、ここ最近の諸事情を鑑み、発行者の要請により、
              {moment(project.failed_at).format('YYYY年MM月DD日')}
              をもちまして、募集の取扱いが取り下げられました。
            </div>
          );
        }
      } else {
        return (
          <div className="description">
            このプロジェクトは
            {moment(project.finish_at).format('YYYY年MM月DD日')}
            をもちまして募集を終了いたしましたのでお申込みいただく事はできません。
            なお、このプロジェクトは募集期間終了日において目標募集額を下回ったため不成立となり、お申込みいただいたご注文は取り消されました。
          </div>
        );
      }
    }
  } else if (
    moment(project.start_at).isAfter(moment()) ||
    project.products_size === 0
  ) {
    return (
      <div className="description">
        このプロジェクトは現在情報の開示をおこなっておりますが、お申込みいただくことはできません。お申込みの開始は
        {moment(project.start_at).format('YYYY年MM月DD日 HH:mm')}
        の予定です。
      </div>
    );
  } else {
    if (project.editor_version === EDITOR.normal) {
      return (
        <div className="description">
          {stripTags(project.short_description)}
        </div>
      );
    } else {
      return (
        <div className="description">
          <span>
            {project.description_vc_invested === true
              ? 'VC出資実績あり / '
              : 'VC出資実績なし / '}
          </span>
          <span>
            {project.description_company_invested === true
              ? '事業者・CVC出資実績あり / '
              : '事業者・CVC出資実績なし / '}
          </span>
          <span>
            {project.description_angel_invested === true
              ? 'エンジェル出資実績あり / '
              : 'エンジェル出資実績なし / '}
          </span>
          <span>
            {project.description_fundinno_funded === true
              ? 'FUNDINNO調達実績あり / '
              : 'FUNDINNO調達実績なし / '}
          </span>
          <span>{surplusName()} / </span>
          <span>
            {project.description_service_launched === true
              ? 'サービス展開済み / '
              : 'サービス展開前 / '}
          </span>
          <span>{patentName()} / </span>
          <span>{stockTypeName()} / </span>
          <span>{angelTypeName()} / </span>
          <span>{shareholderBenefitName()}</span>
        </div>
      );
    }
  }
}
